import React, { useRef, useState } from 'react';
import { MaterialIcons, MaterialUICore } from '@iclinic/design-system';

import { ButtonStyled, TextContainer, TopContainer } from './MoreButton.styled';

const { MoreHoriz } = MaterialIcons;
const { Menu, MenuItem, ListItemText } = MaterialUICore;

export const MoreButton = ({
  togglePatientWaitingList,
  toggleScheduleObservation,
  openScheduleSettings,
}: Readonly<{
  togglePatientWaitingList: () => void;
  toggleScheduleObservation: () => void;
  openScheduleSettings?: () => void;
}>) => {
  const menuAnchorRef = useRef<HTMLDivElement>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuClick = (action: () => void) => () => {
    action();
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <ButtonStyled
        type="button"
        onClick={() => setAnchorEl(menuAnchorRef.current)}
      >
        <TopContainer>
          <MoreHoriz />
        </TopContainer>
        <TextContainer>Mais opções</TextContainer>
      </ButtonStyled>
      <Menu
        id="choice-prize"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleMenuClick(togglePatientWaitingList)}>
          <ListItemText>Lista de espera</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleMenuClick(toggleScheduleObservation)}>
          <ListItemText>Observações</ListItemText>
        </MenuItem>
        {openScheduleSettings && (
          <MenuItem onClick={handleMenuClick(openScheduleSettings)}>
            <ListItemText>Agendamento online</ListItemText>
          </MenuItem>
        )}
      </Menu>
      <div ref={menuAnchorRef} />
    </div>
  );
};
